import axiosHttp from './axios';
import config from '../../config';
import {authconfig} from '../shared/utils/common';
import { getCookie } from '../shared/utils/format.helpers';
import { errorOccuredAndLogged_Mixpanel} from '../shared/mixpanel/mixpanel';
import { CONNECTIVITY_ISSUE, NETWORK_ISSUE, USER_INPUT_ERROR, NETWORK_ERROR, GET_STARTED_FORM_SUBMIT_CALL } from '../constants/mixPannelConstants';


export const makeGetStartedFormSubmitCall = async(formData)=> {
	let configs = authconfig(config.env, 'merchant');
	configs.headers = {...configs.headers, 'authorization': `Bearer ${getCookie('_appToken')}`}
	// console.log('CONFIG ', configs)
	const url = process.env.MERCHANT_SERVICE_API+`/merchants/new`;
	try {
		const response = await axiosHttp.post(url, formData, configs);
		return response.data;
	} catch (error) {
		if (error && error?.response && error?.response?.status === 500) {
			errorOccuredAndLogged_Mixpanel(error, GET_STARTED_FORM_SUBMIT_CALL, USER_INPUT_ERROR);
		} else if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, GET_STARTED_FORM_SUBMIT_CALL, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, GET_STARTED_FORM_SUBMIT_CALL, CONNECTIVITY_ISSUE);
		}
		return error?.response;
		//throw err;
	}
}
